/**
 * Header interactions: compress-on-scroll shadow/padding, mobile menu toggle,
 * search bar toggle. Mirrors Header.tsx's `compressed`/`mobileOpen` state.
 */
(function () {
  var inner = document.getElementById('SiteHeaderInner');
  var logoEn = document.getElementById('LogoEn');
  var logoIt = document.getElementById('LogoIt');
  var mobileToggle = document.getElementById('MobileMenuToggle');
  var mobileMenu = document.getElementById('MobileMenu');
  var iconOpen = document.getElementById('MobileMenuIconOpen');
  var iconClose = document.getElementById('MobileMenuIconClose');
  var searchToggle = document.getElementById('SearchToggle');
  var searchBar = document.getElementById('SearchBar');

  function onScroll() {
    if (!inner) return;
    var compressed = window.scrollY > 40;
    inner.classList.toggle('py-2', compressed);
    inner.classList.toggle('py-4', !compressed);
    inner.classList.toggle('shadow-[0_1px_20px_rgba(60,25,13,0.08)]', compressed);
    [logoEn, logoIt].forEach(function (el) {
      if (!el) return;
      el.classList.toggle('text-xl', compressed);
      el.classList.toggle('text-2xl', !compressed);
    });
  }

  if (inner) {
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.classList.contains('hidden');
      mobileMenu.classList.toggle('hidden', isOpen);
      iconOpen.classList.toggle('hidden', !isOpen);
      iconClose.classList.toggle('hidden', isOpen);
      mobileToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileToggle.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
    });
  }

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('hidden');
      if (!searchBar.classList.contains('hidden')) {
        var input = document.getElementById('HeaderSearchInput');
        if (input) input.focus();
      }
    });
  }
})();
